import $ from 'swiper/esm/utils/dom';
import {scrollTop, scrollTo} from 'dom7/dom7.esm';
$.fn['scrollTop'] = scrollTop;
$.fn['scrollTo'] = scrollTo;

let common = require('./modules/common');

common.init();

let internals = {
    newsSlider: null,
    productsSlider: null,
    mainSlider: null,
    initMainSlider: function (Swiper) {
        internals.mainSlider = new Swiper('#slider_main', {
            autoplay: {
                delay: document.getElementById('slider_main').getAttribute('data-interval'),
            },
            loop: false,
            lazy: {
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            watchSlidesVisibility: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            slidesPerView: 1,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
                bulletClass: 'slider-main__bullet',
                bulletActiveClass: 'slider-main__bullet--active'
            }
        });
    },
    initProductSlider: function (Swiper) {
        internals.productsSlider = new Swiper('#slider_products', {
            autoplay: false,
            loop: false,
            lazy: {
                loadPrevNext: true,
                loadOnTransitionStart: true
            },
            spaceBetween: 20,
            slidesPerView: 'auto',
            allowTouchMove: true,
            slideClass: 'index-products__item',
            wrapperClass: 'index-products__wrap',
            watchSlidesVisibility: true,
            breakpoints: {
                998: {
                    spaceBetween: 0,
                    allowTouchMove: false
                }
            }
        });
    },
    initNewsSlider: function (Swiper) {
        internals.newsSlider = new Swiper('#slider_news', {
            autoplay: false,
            loop: false,
            init: false,
            spaceBetween: 0,
            slidesPerView: 'auto',
            allowTouchMove: true,
            breakpoints: {
                998: {
                    allowTouchMove: false
                }
            },
        });

        common.observeSlider('slider_news', internals.newsSlider);
    }
};

import(/* webpackChunkName: "swiper" */ './modules/swiper').then(function (module) {
    internals.initMainSlider(module.default);
    internals.initProductSlider(module.default);
    internals.initNewsSlider(module.default);
}, function (e) {
    throw new Error('Unable to load swiper library: ' + e.message);
});